import _ from 'lodash';
import { useParams } from "react-router-dom";
import { currency } from "../../../common/services/common.service";
import { useEffect, useState } from 'react';
import { selectprogramsQueryItems } from '../../../redux/programs/selector';
import { useSelector } from 'react-redux';
import { programs } from '../../../redux/programs/action';
import { useAppDispatch } from '../../../hooks/hooks';
import { SubscriptionForm } from './subscription-form';
import { selectendpointsListItems } from '../../../redux/endpoints/selector';
import { endpoints } from '../../../redux/endpoints/action';
import { selectenvironmentsListItems } from '../../../redux/environments/selector';
import { selectnetworksListItems } from '../../../redux/networks/selector';
import { selectphasesListItems } from '../../../redux/phases/selector';
import { selectdigitalPrivateInfrastructuresListItems } from '../../../redux/digital-private-infrastructures/selector';
import { selectdigitalPublicInfrastructuresListItems } from '../../../redux/digital-public-infrastructures/selector';
import { selectservicesListItems } from '../../../redux/services/selector';
import { environments } from '../../../redux/environments/action';
import { networks } from '../../../redux/networks/action';
import { phases } from '../../../redux/phases/action';
import { digitalPrivateInfrastructures } from '../../../redux/digital-private-infrastructures/action';
import { digitalPublicInfrastructures } from '../../../redux/digital-public-infrastructures/action';
import { services } from '../../../redux/services/action';
import { selectapplicationsListItems } from '../../../redux/applications/selector';
import { applications } from '../../../redux/applications/action';

export default function SubscriptionDetails() {
  const dispatch = useAppDispatch();
  const [dbaasProgram, setDBaasProgram] = useState<any>(null);
  const itemsData = useSelector(selectprogramsQueryItems);
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const endpointItems = useSelector(selectendpointsListItems);
  const environmentItems = useSelector(selectenvironmentsListItems);
  const networkItems = useSelector(selectnetworksListItems);
  const applicationItems = useSelector(selectapplicationsListItems)
  const phasesItems = useSelector(selectphasesListItems);
  const serviceItems = useSelector(selectservicesListItems);
  const privateItems = useSelector(selectdigitalPrivateInfrastructuresListItems);
  const publicItems = useSelector(selectdigitalPublicInfrastructuresListItems);
  const params: any = useParams();

  const fetchProgramById = () => {
    dispatch(programs.query({
      url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/query`,
      entity: 'programs',
      jsonData: {
        Records: [{ "Id": params?.id }]
      }
    })).then(() => {
      setIsQuery(true);
    });
  };

  useEffect(() => {
    dispatch(endpoints.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/endpoints/list`, entity: 'endpoints', jsonData: {} }))
      .then(() => {
        dispatch(environments.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/environments/list`, entity: 'endpoints', jsonData: {} }));
      }).then(() => {
        dispatch(networks.list({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`, entity: 'endpoints', jsonData: {} }));
      }).then(() => {
        dispatch(phases.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/phases/list`, entity: 'phases', jsonData: {} }));
      }).then(() => {
        dispatch(digitalPrivateInfrastructures.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-private-infrastructures/list`, entity: 'digitalPrivateInfrastructures', jsonData: {} }));
      }).then(() => {
        dispatch(digitalPublicInfrastructures.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/digital-public-infrastructures/list`, entity: 'digitalPublicInfrastructures', jsonData: {} }));
      }).then(() => {
        dispatch(services.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/services/list`, entity: 'services', jsonData: {} }));
      }).then(() => {
        dispatch(applications.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/applications/list`,entity:'applications',jsonData:{}}))}).then(() => {
        fetchProgramById();
      });
  }, []);

  useEffect(() => {
    if (isQuery) {
      setDBaasProgram(itemsData?.result?.items);
    }
  }, [isQuery, itemsData]);

  const getNameById = (id: any, list: any) => {
    const item = list.find((item: any) => item.Id === id);
    return item ? item.Name : id;
  };

  const image = require('../../../assets/img/image 1.png');

  return (
    <div className="contact-wrapper w-full p-10 mb-10">
  <div className="container-x mx-auto">
    <div className="main-wrapper w-full lg:flex lg:space-x-10 lg:items-stretch">
      {/* Program Details Section */}
      <div className="lg:w-2/3 w-full mb-10 lg:mb-0 flex flex-col">
        <div className="p-6 rounded-lg bg-white shadow-md mb-6 flex-grow">
          <h1 className="text-blue-900 font-bold text-3xl mb-4">
            {`${dbaasProgram?.Name} Subscription`}
          </h1>
          <div className="flex items-center justify-between p-4 rounded-lg bg-blue-100 shadow-md h-30 mt-12">
            <div>
              <h2 className="text-blue-900 text-2xl font-bold">Cost</h2>
              <h3 className="mt-2 text-3xl font-bold text-yellow-500 text-left">
                {currency(dbaasProgram?.DBaaSProgram[0]?.Price)}
              </h3>
            </div>
            <div className="bg-gradient-to-tr from-yellow-500 to-yellow-400 w-32 h-32 rounded-full shadow-2xl shadow-yellow-400 border-white border-dashed border-2 flex justify-center items-center">
              <div>
                <h1 className="text-white text-2xl text-center">
                  Validity <br />
                  {`${dbaasProgram?.DBaaSProgram[0]?.ProgramDuration}`}
                </h1>
              </div>
            </div>
          </div>
          <div className="p-4 rounded-lg bg-white shadow-md mt-6 w-full flex-grow">
            <h3 className="text-2xl font-medium text-blue-900 mb-4">
              Program Details
            </h3>
            {dbaasProgram && (
              <div className="table w-full mt-10">
                <div className="table-row-group">
                  {[
                    { label: 'DBaas End Points', value: dbaasProgram?.DBaaSProgram[0]?.DBaaSEndPointIds, list: endpointItems?.result?.items },
                    { label: 'DBaas Environments', value: dbaasProgram?.DBaaSProgram[0]?.DBaaSEnvironmentIds, list: environmentItems?.result?.items },
                    { label: 'DBaas Networks', value: dbaasProgram?.DBaaSProgram[0]?.DBaaSNetworkIds, list: networkItems?.result?.items },
                    { label: 'DBaas Applications', value: dbaasProgram?.ApplicationMappings?.ApplicationIds, list: applicationItems?.result?.items },
                    { label: 'DBaas Phases', value: dbaasProgram?.DBaaSProgram[0]?.DBaaSPhaseIds, list: phasesItems?.result?.items },
                    { label: 'DBaaS Services', value: dbaasProgram?.DBaaSProgram[0]?.DBaaSServiceIds, list: serviceItems?.result?.items },
                    { label: 'Digital Private Infrastructures', value: dbaasProgram?.DBaaSProgram[0]?.DigitalPrivateInfrastructureIds, list: privateItems?.result?.items },
                    { label: 'Digital Public Infrastructures', value: dbaasProgram?.DBaaSProgram[0]?.DigitalPublicInfrastructureIds, list: publicItems?.result?.items },
                  ].map((item, index) => (
                    <div key={index} className={`table-row ${index % 2 === 0 ? 'bg-gray-100' : ''}`}>
                      <div className="table-cell p-2 text-md font-semibold">{item.label}</div>
                      <div className="table-cell p-2">
                        {item.value.map((id: any) => (
                          <div key={id}>{getNameById(id, item.list)}</div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* Subscription Form Section */}
      <div className="lg:w-1/3 w-full flex flex-col items-center lg:items-start space-y-6 flex-grow">
        <div className="w-full flex flex-col items-center flex-grow">
          <div className="flex-grow flex items-center justify-center">
            <img
              src={
                dbaasProgram?.MediaMappings?.MediaFiles[0]?.FileMappingURL ||
                image
              }
              alt="DBaaS Program"
              className="rounded-lg shadow-md object-contain max-h-full max-w-full"
            />
          </div>
        </div>
        <div className="w-full p-6 bg-white shadow-md rounded-lg flex-grow mb-1"> 
          <SubscriptionForm item={dbaasProgram} />
        </div>
      </div>
    </div>
  </div>
</div>
  );
}